import type { RouteObject } from 'react-router';

import type { RouteHandle } from '@/hooks/useRouteHandle';

const page = (name: string) => () =>
  import(`./pages/${name}.tsx`).then((m) => ({ Component: m[name] }));

/** 비로그인 공개 화면(specs/070) — FO 기본 레이아웃(헤더·푸터). */
export const publicSiteRoutes: RouteObject[] = [
  {
    path: 'programs',
    lazy: page('ProgramsBrowsePage'),
    handle: { title: '지원사업 둘러보기' } satisfies RouteHandle,
  },
  {
    path: 'programs/:id',
    lazy: page('ProgramPublicDetailPage'),
    handle: { title: '공고 상세' } satisfies RouteHandle,
  },
  {
    path: 'featured',
    lazy: page('FeaturedProgramsPage'),
    handle: { title: '올해 꼭 보는 사업' } satisfies RouteHandle,
  },
];
